import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Briefcase, Settings, Camera, LineChart } from 'lucide-react';
import { Currency, Holding } from '../types';
import { Select } from './ui/Forms';
import { CURRENCIES, getCurrencyInfo } from '../utils/countries';
interface NavbarProps {
  baseCurrency: Currency;
  setBaseCurrency: (c: Currency) => void;
  holdings: Holding[];
}
export function Navbar({
  baseCurrency,
  setBaseCurrency,
  holdings
}: NavbarProps) {
  const location = useLocation();
  const navItems = [{
    path: '/',
    label: 'Dashboard',
    icon: LayoutDashboard
  }, {
    path: '/projections',
    label: 'Projections',
    icon: LineChart
  }, {
    path: '/holdings',
    label: 'Holdings',
    icon: Briefcase
  }, {
    path: '/snapshots',
    label: 'Snapshots',
    icon: Camera
  }, {
    path: '/settings',
    label: 'Settings',
    icon: Settings
  }];
  return <header className="bg-white/80 backdrop-blur-xl border-b border-slate-200/60 sticky top-0 z-40" data-id="element-1071">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between" data-id="element-1072">
        <div className="flex items-center gap-8" data-id="element-1073">
          <Link to="/" className="flex items-center gap-2 group" data-id="element-1074">
            <img src="https://cdn.magicpatterns.com/uploads/sfi3oXipchL5LQrtC4MqUT/pairfolio_logo_2.png" alt="Pairfolio" className="w-8 h-8 object-contain" data-id="element-1075" />
            <span className="text-lg font-semibold text-slate-900 tracking-tight hidden sm:block" data-id="element-1076">
              Pairfolio
            </span>
          </Link>

          <nav className="flex items-center gap-0.5" data-id="element-1077">
            {navItems.map(item => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;
            return <Link key={item.path} to={item.path} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[13px] font-medium transition-all ${isActive ? 'bg-blue-600 text-white' : 'text-slate-500 hover:text-slate-900 hover:bg-slate-100'}`} data-id="element-1078">
                  <Icon className={`w-3.5 h-3.5 ${isActive ? 'text-white' : 'text-slate-400'}`} data-id="element-1079" />
                  <span className="hidden sm:inline" data-id="element-1080">{item.label}</span>
                </Link>;
          })}
          </nav>
        </div>

        <div className="flex items-center gap-3" data-id="element-1081">
          <Select searchable value={baseCurrency} onChange={e => setBaseCurrency(e.target.value as Currency)} className="w-32" options={(() => {
          // Get unique currencies from holdings, always include baseCurrency
          const uniqueCurrencies = new Set<string>([baseCurrency]);
          holdings.forEach(h => uniqueCurrencies.add(h.currency));
          // If no holdings, provide a few defaults
          if (uniqueCurrencies.size === 1) {
            ;
            ['USD', 'EUR', 'GBP'].forEach(c => uniqueCurrencies.add(c));
          }
          return Array.from(uniqueCurrencies).map(code => {
            const info = getCurrencyInfo(code);
            return {
              value: code,
              label: `${info.flag} ${code}`
            };
          });
        })()} data-id="element-1082" />
        </div>
      </div>
    </header>;
}